"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var skynet_store_authentication_api_1 = require("@synisys/skynet-store-authentication-api");
var initialState = {
    token: undefined,
    error: undefined,
};
function authenticationReducer(state, action) {
    if (state === void 0) { state = initialState; }
    // tslint:disable-next-line:no-var-keyword
    switch (action.type) {
        case skynet_store_authentication_api_1.AuthenticationActionTypes.AuthenticationSuccess: {
            return __assign({}, state, { token: action.payload });
        }
        case skynet_store_authentication_api_1.AuthenticationActionTypes.AuthenticationError: {
            return __assign({}, state, { error: action
                    .payload });
        }
        default: {
            return state;
        }
    }
}
exports.authenticationReducer = authenticationReducer;
//# sourceMappingURL=auth.reducers.js.map